<script>
	import Dispatch from '../../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'

	let mouseStart = 0

  const scale = Dispatch.getState('view.scale')

  export let command
  export let height

</script>

<div class='bg-gray o-50' style={'height: ' +height + 'px; width: ' + ($scale.windowWidth / $scale.songLength) * command.holdtime + 'px;'}></div>
<div 
  class={'bg-moon-gray br1 o-50 '}
  draggable=true 
  style={'height: ' +height + 'px; width: 5px; cursor: e-resize'}
  on:click={e => {e.preventDefault(); e.stopPropagation()}}
  on:dragstart={e => {
    mouseStart = e.offsetX
  }} 
  on:dragend={e => {
    Dispatch.nextAction('script.holdtime', { id: command.id, value: e.offsetX - mouseStart })
  }}
></div>

<style>
</style>